import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { BannerWowGo } from "../page/banner/banner";

@Injectable({
  providedIn: 'root'
})
export class BannerService {
  apiURL: string = environment.apiBaseUrl + 'banner';

  constructor(private http: HttpClient) { }

  listarBanners(page: number, size: number): Observable<any> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}?${params.toString()}`);
  }

  consultarPorId(id: number): Observable<BannerWowGo> {
    return this.http.get<any>(`${this.apiURL}/${id}`);
  }

  salvar(banner: BannerWowGo): Observable<BannerWowGo> {
    return this.http.post<BannerWowGo>(this.apiURL, banner);
  }

  alterar(banner: BannerWowGo): Observable<BannerWowGo> {
    return this.http.put<BannerWowGo>(`${this.apiURL}`, banner);
  }

  buscar(page: number, qtdItemPagina: number, filtro: string, descricao: string, ativo: boolean) {
    const params = new HttpParams()
      .set('pagina', page.toString())
      .set('qtdItemPagina', qtdItemPagina.toString())
      .set("filtro", filtro)
      .set("descricao", descricao)
      .set("ativo", ativo)
    return this.http.get<any>(`${this.apiURL}/consulta?${params.toString()}`);
  }

  deletar(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiURL}/${id}`);
  }
}